"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.forEach = void 0;
const JSON_1 = require("./JSON");
function forEachObject(object, fn) {
    for (let key in object) {
        fn(object[key], key, object);
    }
}
function forEach(container, fn) {
    if ((0, JSON_1.isObject)(container)) {
        return forEachObject(container, fn);
    }
    return container.forEach(fn);
}
exports.forEach = forEach;
